module.exports = __webpack_public_path__ + "img/1519145990.79d76849.jpg";